import { PortalSessionStatusEnum } from './portal-session-status.enum';

export interface PortalSessionInterface {
  id?: string;
  token?: string;
  accessUrl?: string;
  status?: PortalSessionStatusEnum;
  createdAt?: number;
  expiresAt?: number;
  customerId?: string;
}
